var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 21H18C18.7956 21 19.5587 20.6997 20.1213 20.1653C20.6839 19.6308 21 18.9059 21 18.15V6.75C21 6.24609 20.7893 5.76282 20.4142 5.4065C20.0391 5.05018 19.5304 4.85 19 4.85H17V2.95C17 2.69804 16.8946 2.45641 16.7071 2.27825C16.5196 2.10009 16.2652 2 16 2C15.7348 2 15.4804 2.10009 15.2929 2.27825C15.1054 2.45641 15 2.69804 15 2.95V4.85H9V2.95C9 2.69804 8.89464 2.45641 8.70711 2.27825C8.51957 2.10009 8.26522 2 8 2C7.73478 2 7.48043 2.10009 7.29289 2.27825C7.10536 2.45641 7 2.69804 7 2.95V4.85H5C4.46957 4.85 3.96086 5.05018 3.58579 5.4065C3.21071 5.76282 3 6.24609 3 6.75V18.15C3 18.9059 3.31607 19.6308 3.87868 20.1653C4.44129 20.6997 5.20435 21 6 21ZM5 11.975C5 11.849 5.05268 11.7282 5.14645 11.6391C5.24021 11.55 5.36739 11.5 5.5 11.5H18.5C18.6326 11.5 18.7598 11.55 18.8536 11.6391C18.9473 11.7282 19 11.849 19 11.975V18.15C19 18.402 18.8946 18.6436 18.7071 18.8218C18.5196 18.9999 18.2652 19.1 18 19.1H6C5.73478 19.1 5.48043 18.9999 5.29289 18.8218C5.10536 18.6436 5 18.402 5 18.15V11.975Z",
    fill: "url(#paint0_linear_2050_11279)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2050_11279",
    x1: 12,
    y1: 2,
    x2: 12,
    y2: 21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30AC72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60C946"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarGreen);
export default __webpack_public_path__ + "static/media/calendarGreen.fe5ae6499b6ea8b366714a8e2a0e4951.svg";
export { ForwardRef as ReactComponent };